export const CLOUD_DVIR_TAG = 'CloudDvir';
